module.exports = __webpack_public_path__ + "img/stock-photo-laughing-cheerful-funny-young-bearded-business-man-s_2x.b0fde63e.webp";